/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindAllQueryResponse, PromptsControllerFindAllQueryParams, PromptsControllerFindAll401, PromptsControllerFindAll403 } from "../../models/promptsController/PromptsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { promptsControllerFindAll } from "../../clients/promptsService/promptsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const promptsControllerFindAllQueryKey = (params: PromptsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/prompts'
}, ...(params ? [params] : [])] as const;
export type PromptsControllerFindAllQueryKey = ReturnType<typeof promptsControllerFindAllQueryKey>;
export function promptsControllerFindAllQueryOptions(params?: PromptsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = promptsControllerFindAllQueryKey(params);
  return queryOptions<PromptsControllerFindAllQueryResponse, ResponseErrorConfig<PromptsControllerFindAll401 | PromptsControllerFindAll403>, PromptsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return promptsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all prompts with filtering and pagination
 * {@link /api/v1/prompts}
 */
export function usePromptsControllerFindAll<TData = PromptsControllerFindAllQueryResponse, TQueryData = PromptsControllerFindAllQueryResponse, TQueryKey extends QueryKey = PromptsControllerFindAllQueryKey>(params?: PromptsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<PromptsControllerFindAllQueryResponse, ResponseErrorConfig<PromptsControllerFindAll401 | PromptsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? promptsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...promptsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PromptsControllerFindAll401 | PromptsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}